import { computed } from 'mobx';
import {
    AgentLoanApiFindAllAgentLoansRequest,
    GetAgentLoan200Response,
    LoanDtoBrief,
} from 'src/generated-api-client';
import {
    agentLoansApi,
    bpmsResourcesManagerApi,
} from 'src/services/apiServices';
import { ListFilter } from 'src/utils/FormHelper';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { FilterCriteria } from 'src/utils/mobx/FilterCriteria';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

export type AgentLoansFilter = ListFilter<AgentLoanApiFindAllAgentLoansRequest>;

export class AgentLoansStoreClass extends BasicStore<
    LoanDtoBrief,
    AgentLoansFilter,
    GetAgentLoan200Response,
    GetAgentLoan200Response,
    GetAgentLoan200Response
> {
    itemPathKey = 'loanId';
    itemDetailsFormKey = 'embedded:deployment:forms/ap/ap-09-loan.json';

    pager = new Pager();
    sorter = new Sorter();
    filterCriteria = new FilterCriteria<AgentLoansFilter>();

    api: BasicStoreApi<LoanDtoBrief, GetAgentLoan200Response> = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);
            const response = await RequestHelper.unwrapFromAxiosPromise(
                agentLoansApi.findAllAgentLoans(
                    {
                        ...this.pager,
                        ...this.sorter,
                        ...this.filterCriteria.filter,
                    },
                    options,
                ),
            );

            this.pager.setTotal(response.totalElements || 0);

            return response.content || [];
        },
        loadItem: (id, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                agentLoansApi.getAgentLoan({ id }, options),
            );
        },
        loadItemForm: (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm(
                    { formKey: this.itemDetailsFormKey },
                    options,
                ),
            );
        },
    };

    @computed get hasFilter() {
        return (
            Boolean(this.filterCriteria.filter.filterStatuses) ||
            (Boolean(this.filterCriteria.filter.filterIssueDateFrom) &&
                Boolean(this.filterCriteria.filter.filterIssueDateTo))
        );
    }
}

export const AgentLoansStore = new AgentLoansStoreClass();
